import React, { SVGProps } from 'react'
const SvgLinked = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <g fill={props.fill || 'var(--color-cta)'} fillRule="nonzero">
      <path d="M11.243 16.876 8.9 19.043c-.971.899-2.544.899-3.515 0-.97-.898-.97-2.353 0-3.25l4.687-4.337c.97-.898 2.543-.898 3.514 0 .323.3.848.3 1.171 0a.727.727 0 0 0 0-1.084c-1.617-1.496-4.24-1.496-5.857 0l-4.687 4.336c-1.617 1.497-1.617 3.923 0 5.419 1.618 1.497 4.24 1.497 5.859 0l2.342-2.167a.727.727 0 0 0 0-1.084.877.877 0 0 0-1.171 0Z" />
      <path d="M20.832 4.083c-1.557-1.444-4.081-1.444-5.638 0l-2.706 2.51a.703.703 0 0 0 0 1.047.842.842 0 0 0 1.128 0l2.706-2.51c.934-.867 2.449-.867 3.383 0a2.107 2.107 0 0 1 0 3.138l-4.962 4.602c-.934.867-2.448.867-3.382 0a.842.842 0 0 0-1.127 0 .703.703 0 0 0 0 1.047c1.556 1.444 4.08 1.444 5.637 0l4.961-4.603c1.557-1.445 1.557-3.786 0-5.23Z" />
    </g>
  </svg>
)
export default SvgLinked
